import { useEffect } from 'react';

export function usePreventLeave(shouldPrevent: boolean) {
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (!shouldPrevent) return;
      e.preventDefault();
      e.returnValue = '';
    };

    if (shouldPrevent) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [shouldPrevent]);
}
